const ID_RE = /^[A-Za-z0-9_-]{11}$/;

export function parseYouTubeUrl(input: string): string | null {
  const trimmed = input.trim();
  if (ID_RE.test(trimmed)) return trimmed;
  try {
    const u = new URL(trimmed);
    if (u.hostname === 'youtu.be') {
      const id = u.pathname.replace(/^\/|\/$/g, '');
      return ID_RE.test(id) ? id : null;
    }
    if (u.hostname.endsWith('youtube.com')) {
      const v = u.searchParams.get('v');
      if (v && ID_RE.test(v)) return v;
      const liveMatch = u.pathname.match(/^\/live\/([A-Za-z0-9_-]{11})/);
      if (liveMatch?.[1]) return liveMatch[1];
    }
  } catch {
    /* not a URL */
  }
  return null;
}
